<template>
  <div class="wl-school-static-wrpper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1">毕业生就业情况统计表（院校）</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="ph-baisc-head-main">
      <img src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/bWwrCnyQdKFJAZ6b.png" alt />
    </div>
    <div class="basic-form-main">
      <table border="0" cellspacing="0" cellpadding="0" class="school-static-table">
        <tr>
          <td colspan="8">
            <div class="table-head-con">毕业生就业情况统计表（院校）</div>
          </td>
        </tr>
        <tr>
          <td class="td-label">单位名称</td>
          <td>
            <el-input v-model="unitName"></el-input>
          </td>
          <td class="td-label">学校类别</td>
          <td>
            <el-select v-model="schoolType" placeholder clearable>
              <el-option
                v-for="item in schoolOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </td>
          <td class="td-label">地址</td>
          <td colspan="3">
            <el-input v-model="address"></el-input>
          </td>
        </tr>
        <tr>
          <td class="td-label">联系人</td>
          <td>
            <el-input v-model="linkPerson"></el-input>
          </td>
          <td class="td-label">电话</td>
          <td>
            <el-input v-model="linkPhone"></el-input>
          </td>
          <td class="td-label">职务</td>
          <td>
            <el-input v-model="post"></el-input>
          </td>
          <td class="td-label">邮箱</td>
          <td>
            <el-input v-model="email"></el-input>
          </td>
        </tr>
        <tr v-for="(item,index) in majorPerson" :key="index">
          <td class="td-label">专业</td>
          <td colspan="3">
            <span v-if="schoolType == ''" class="sp-text-title"> <i class="wl-icon-tishi"></i> 请先选择学校类别</span>
            <el-select v-model="item.Major" v-if="schoolType == '中职'">
              <el-option
                v-for="item in zzMajor"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="item.Major" v-if="schoolType == '高职'">
              <el-option
                v-for="item in gzMajor"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="item.Major" v-if="schoolType == '本科'">
              <el-option
                v-for="item in bkMajor"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </td>
          <td class="td-label">毕业生人数</td>
          <td colspan="3">
            <el-input v-model="item.GraduateCount" type="number"></el-input>
          </td>
        </tr>
      </table>
      <div class="click-add-line" @click="addLine">
        <i class="wl-icon-tianjia"></i> 点击添加一行
      </div>
      <div class="submit-table-con">
        <el-button type="primary" @click="submitTable" :disabled="isCanSubmit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      unitName: "",
      linkPerson: "",
      linkPhone: "",
      post: "",
      email: "",
      address: "",
      schoolType: "",
      schoolOption: [
        {
          value: "中职",
          label: "中职"
        },
        {
          value: "高职",
          label: "高职"
        },
        {
          value: "本科",
          label: "本科"
        }
      ],
      zzMajor: [
        {
          value: "物流服务与管理",
          label: "物流服务与管理"
        },
        {
          value: "国际货运代理专业",
          label: "国际货运代理专业"
        },
        {
          value: "冷链物流服务与管理专业",
          label: "冷链物流服务与管理专业"
        }
      ],
      gzMajor: [
        {
          value: "物流工程技术",
          label: "物流工程技术"
        },
        {
          value: "物流信息技术",
          label: "物流信息技术"
        },
        {
          value: "物流管理",
          label: "物流管理"
        },
        {
          value: "物流金融管理",
          label: "物流金融管理"
        },
        {
          value: "工程物流管理",
          label: "工程物流管理"
        },
        {
          value: "冷链物流技术与管理",
          label: "冷链物流技术与管理"
        },
        {
          value: "采购与供应管理",
          label: "采购与供应管理"
        },
        {
          value: "铁路物流管理",
          label: "铁路物流管理"
        },
        {
          value: "港口物流管理",
          label: "港口物流管理"
        },
        {
          value: "航空物流",
          label: "航空物流"
        },
        {
          value: "报关与国际货运",
          label: "报关与国际货运"
        }
      ],
      bkMajor: [
        {
          value: "物流管理",
          label: "物流管理"
        },
        {
          value: "物流工程",
          label: "物流工程"
        },
        {
          value: "采购管理",
          label: "采购管理"
        },
        {
          value: "供应链管理",
          label: "供应链管理"
        }
      ],
      majorPerson: [
        {
          Major: "",
          GraduateCount: ""
        }
      ],
      isCanSubmit:false
    };
  },
  created() {},
  methods: {
    addLine() {
      this.majorPerson.push({
        Major: "",
        GraduateCount: ""
      });
    },
    submitTable() {
      if (this.unitName == "") {
        return this.$message.warning("请输入单位名称");
      }
      if (this.schoolType == "") {
        return this.$message.warning("请选择学校类别");
      }
      if (this.address == "") {
        return this.$message.warning("请输入地址");
      }
      if (this.linkPerson == "") {
        return this.$message.warning("请输入联系人");
      }
      if (this.linkPhone == "") {
        return this.$message.warning("请输入联系人电话");
      }
      if (this.majorPerson[0].Major == "") {
        return this.$message.warning("请选择专业");
      }
      if (this.majorPerson[0].GraduateCount == "") {
        return this.$message.warning("请输入毕业生人数");
      }
      let reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      //   if(!reg.test(this.linkPhone)){
      //      return this.$message.warning('请输入联系人电话');
      //   }
      this.$http
        .post("/api/XOrg/Statistics/editOrAddSchoolEnterprise", {
          companyName: this.unitName,
          schoolType: this.schoolType,
          schoolAddress: this.address,
          contacts: this.linkPerson,
          contactsPhone: this.linkPhone,
          job: this.post,
          email: this.email,
          json: JSON.stringify(this.majorPerson),
          type: 1
        })
        .then(res => {
          if (res.code > 0) {
            this.isCanSubmit = true;
            return this.$message.success("提交成功");
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wl-school-static-wrpper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 46px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .phone-head-main {
    display: none;
    background: #056ef5;
    text-align: center;
    color: #fff;
  }
  .basic-form-main {
    margin: 0 auto;
    margin-top: -325px;
    padding: 20px 0;
    width: 1060px;
    min-height: 400px;
    background: #fff;
  }
  .school-static-table {
    margin: 0 auto;
    width: 1030px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
    td {
      border-left: 1px solid #999;
      border-top: 1px solid #999;
      text-align: center;
    }
    .el-textarea__inner,
    .el-input__inner {
      border: none;
      font-size: 16px;
      color: #000;
    }
    .el-textarea__inner:focus {
      border: none;
    }
    .el-input__inner:focus {
      border: none;
    }
     .el-input__inner {
      height: 39px;
      line-height: 39px;
    }
    .el-date-editor.el-input {
      width: 100%;
    }
    .table-head-con {
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
    }
    .el-select,
    .el-input-number {
      width: 100%;
    }
    .td-label {
      font-size: 15px;
    }
  }
  .click-add-line {
    padding: 20px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    color: #0155d1;
  }
  .click-add-line:hover {
    color: #0155d1;
  }
  .submit-table-con {
    margin-top: 30px;
    text-align: center;
  }
  .ph-baisc-head-main {
    display: none;
    img {
      width: 100%;
    }
  }
  .sp-text-title{
    color: #7D8DA4;
  }
}
@media only screen and (max-width:700px) {
  .wl-school-static-wrpper {
    height: auto;
    .basic-head-main {
      display: none;
    }
    .ph-baisc-head-main {
      display: block;
    }
    .phone-head-main {
      display: block;
    }
  }
}
</style>